import api from '../api';

export const acceptTerms = async ({
  termsChecked,
}: {
  termsChecked: boolean;
}) => {
  return api.put('/user/acceptTerms', { termsChecked }).then((r) => r.data);
};
